import React from "react";
import "../styles/App.css";

function Experience() {
  return (
    <section className="experience" id="experience">
      
      <div className="exp-card">
      <h2 style={{ color: "#007bff" }} >Work Experience</h2>
      
        <h3>HomeOne Technologies</h3>
        <p>Full Stack Developer | June 2024 - July 2025 </p>
        
          <p>Developed scalable web applications using React.js, Node.js, and Firebase.</p>
          <p>Implemented real-time features using WebSockets and MQTT.</p>
        
      </div>



    </section>
  );
}

export default Experience;
